import { commonData } from "@/utils";
import * as Sentry from "@sentry/react";
// import { Integrations } from "@sentry/tracing"; // Must import second

// 初始化sentry
Sentry.init({
  dsn: commonData.sentryDns,
  // release: version, // 版本号
  environment: process.env.ENV_NAME,
  integrations: [
    new Sentry.BrowserTracing({
      // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
      tracePropagationTargets: [
        "localhost",
        // /^https:\/\/yourserver\.io\/api/,
        /^https:\/\/dev-lang-platform-api\.golingo\.cn\/api/,
        /^https:\/\/test-lang-platform-api\.golingo\.cn\/api/,
        /^https:\/\/lang-platform-api\.golingo\.cn\/api/,
        /^https:\/\/dev-admin-platform-api\.golingo\.cn\/api/,
        /^https:\/\/test-admin-platform-api\.golingo\.cn\/api/,
        /^https:\/\/admin-platform-api\.golingo\.cn\/api/,
      ],
    }),
    new Sentry.Replay({
      maskAllText: false,
      blockAllMedia: false,
    }),
  ],
  // Performance Monitoring
  tracesSampleRate: 0.3, //  Capture 100% of the transactions
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});
